module.exports = __webpack_public_path__ + "dom_andr_qr.1bd5734.png";